export default __webpack_public_path__ + "static/media/bg2.654c921e.jpg";